const _ = (key) => `bookings/${key}`;
export const SHOW_POPUP = _('showPopup');
export const CLOSE_POPUP = _('closePopup');
export const ADD_BOOKING = _('addBooking');



// WEBPACK FOOTER //
// ./src/core/store/bookings/types/mutations.ts